import { sdk } from 'src/utilities/sdk';
import { IAsyncTaskResponse } from 'src/utilities/useAsyncTask';

export interface AssignAllowanceAmountProps {
  corpId: string;
  mealCreditId: string;
  updatedGroupBudgets: {
    [id: string]: number;
  };
}

export const assignAllowanceAmount = async ({
  corpId,
  mealCreditId,
  updatedGroupBudgets,
}: AssignAllowanceAmountProps): Promise<IAsyncTaskResponse> => {
  return sdk.http.post(
    `/corp-admin/${corpId}/events/${mealCreditId}/people-section/allowance-amount`,
    {
      updated_group_budgets: updatedGroupBudgets,
    }
  );
};
